export const GroundTeamUserActionTypes = {
  SET_GROUND_TEAM_USERS: 'SET_GROUND_TEAM_USERS',
  SET_GROUND_TEAM_DETAILS: 'SET_GROUND_TEAM_DETAILS',
  SET_GROUND_TEAM_DAILY_WORKING_HOURS:'SET_GROUND_TEAM_DAILY_WORKING_HOURS',
  SET_GROUND_TEAM_WORK_RECORD: 'SET_GROUND_TEAM_WORK_RECORD'
};
